// Consistent card styles for the entire application
export const cardStyles = {
  base: {
    backgroundColor: 'white',
    border: '1px solid #f1f5f9',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04)',
      transform: 'translateY(-1px)'
    }
  },
  
  // Variant without hover effects for static cards
  static: {
    backgroundColor: 'white',
    border: '1px solid #f1f5f9',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)'
  },
  
  // Variant with stronger shadow for important cards
  elevated: {
    backgroundColor: 'white',
    border: '1px solid #f1f5f9',
    borderRadius: '12px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      transform: 'translateY(-2px)'
    }
  }
};